<template>
  <div>
    <small class="text-uppercase">{{ $t("case_number") }}</small>
    <br />
    {{ rpsCase.case_number }}
    <br />
    <base-button tabindex="-1" size="sm" @click="del()" v-if="showDelete"
      >{{ $t("delete") }} <font-awesome-icon style="cursor: pointer;" icon="minus"
    /></base-button>
    <base-button tabindex="-1" size="sm" @click="down()" v-if="showDown"
      >{{ $t("down") }} <font-awesome-icon style="cursor: pointer;" icon="arrow-down"
    /></base-button>
    <base-button tabindex="-1" size="sm" @click="up()" v-if="showUp"
      >{{ $t("up") }} <font-awesome-icon style="cursor: pointer;" icon="arrow-up"
    /></base-button>
    <br />
    <br />

    <small class="text-uppercase">{{ $t("title") }}</small>
    &nbsp;<base-button tabindex="-1" @click="showTitle = !showTitle" size="sm" type="primary">{{
      $t("example")
    }}</base-button>
    <br />
    <EditorHelpImage type="rps-case-title" v-if="showTitle" />
    <input
      maxLength="1000"
      id="input-title"
      v-model.lazy="rpsCase.title"
      tabindex="0"
      @input="debounce_inputs"
      :class="!rpsCase.title || rpsCase.title.length === 0 ? 'error form-control' : 'form-control'"
      v-b-tooltip.hover.bottom="otherLocalesHoverText('title')"
    />

    <br />
    <small class="text-uppercase">{{ $t("description") }}</small>

    &nbsp;<base-button
      tabindex="-1"
      @click="showDescription = !showDescription"
      size="sm"
      type="primary"
      >{{ $t("example") }}</base-button
    >
    <br />
    <EditorHelpImage type="rps-case-description" v-if="showDescription" />

    <textarea
      class="form-control"
      v-if="false"
      rows="5"
      id="input-description"
      v-model.lazy="rpsCase.description"
      tabindex="0"
      @input="debounce_inputs"
      v-b-tooltip.hover.bottom="otherLocalesHoverText('description')"
    >
    </textarea>
    <vue-editor
      :editor-toolbar="customToolbar"
      v-model.lazy="rpsCase.description"
      @input="debounce_inputs"
      id="input-description"
      tabindex="0"
      v-b-tooltip.hover.bottom="otherLocalesHoverText('description')">
    </vue-editor>
        
     <br />

    <small class="text-uppercase">{{ $t("case_question") }}</small>
    &nbsp;<base-button
      tabindex="-1"
      @click="showCaseQuestion = !showCaseQuestion"
      size="sm"
      type="primary"
      >{{ $t("example") }}</base-button
    >
    <br />
    <EditorHelpImage type="rps-case-question" v-if="showCaseQuestion" />

    <input
      maxLength="1000"
      id="input-case_question"
      v-model.lazy="rpsCase.case_question"
      tabindex="0"
      @input="debounce_inputs"
      :class="!rpsCase.case_question || rpsCase.case_question.length === 0 ? 'error form-control' : 'form-control'"
      v-b-tooltip.hover.bottom="otherLocalesHoverText('case_question')"
    />
    <br />

    <small class="text-uppercase">{{ $t("description_above_cases") }}</small>
    &nbsp;<base-button
      tabindex="-1"
      @click="showDescriptionAboveCases = !showDescriptionAboveCases"
      size="sm"
      type="primary"
      >{{ $t("example") }}</base-button
    >
    <br />
    <EditorHelpImage type="rps-case-description-above-cases" v-if="showDescriptionAboveCases" />

    <input
      maxLength="1000"
      id="input-description_above_cases"
      class="form-control"
      v-model.lazy="rpsCase.description_above_cases"
      tabindex="0"
      @input="debounce_inputs"
      v-b-tooltip.hover.bottom="otherLocalesHoverText('description_above_cases')"
    />
    <br />

    <small class="text-uppercase">{{ $t("description_below_cases") }}</small>
    &nbsp;<base-button
      tabindex="-1"
      @click="showDescriptionBelowCases = !showDescriptionBelowCases"
      size="sm"
      type="primary"
      >{{ $t("example") }}</base-button
    >
    <br />

    <EditorHelpImage type="rps-case-description-below-cases" v-if="showDescriptionBelowCases" />
    <input
      maxLength="1000"
      id="input-description_below_cases"
      class="form-control"
      v-model.lazy="rpsCase.description_below_cases"
      tabindex="0"
      @input="debounce_inputs"
      v-b-tooltip.hover.bottom="otherLocalesHoverText('description_below_cases')"
    />
    <br />

    <small class="text-uppercase">{{ $t("facilitator_instructions") }}</small>
    <br />
    <textarea
      class="form-control"
      rows="5"
      id="input-facilitator_instructions"
      v-model.lazy="rpsCase.facilitator_instructions"
      tabindex="0"
      @input="debounce_inputs"
      v-b-tooltip.hover.bottom="otherLocalesHoverText('facilitator_instructions')"
    />
    <br />
  </div>
</template>

<script>
import Vue from "vue";
import EditorHelpImage from "@/components/EditorHelpImage.vue";
import { VueEditor, Quill } from "vue2-editor";

const debounce = require("lodash.debounce");


///
function getFontName(font) {
    return font.toLowerCase().replace(/\s/g, "-");
}

const fontNames = [
  'Poppins',
  'Arial',
  'Helvetica',
  'Times New Roman',
  'Verdana'
];

const fontList = [
  'Poppins',
  'Arial',
  'Helvetica',
  'Times New Roman',
  'Verdana'
];

const fonts = Quill.import('formats/font');
fonts.whitelist = fontNames;
Quill.register(fonts, true);

// Add fonts to CSS style
let fontStyles = "";
fontList.forEach((font) => {
    const fontName = getFontName(font);
    fontStyles += ".ql-snow .ql-picker.ql-font .ql-picker-label[data-value=" + fontName + "]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=" + fontName + "]::before {" +
        "content: '" + font + "';" +
        "font-family: '" + font + "', sans-serif;" +
        "}" +
        ".ql-font-" + fontName + "{" +
        " font-family: '" + font + "', sans-serif;" +
        "}";
});

// https://stackoverflow.com/questions/68394460/add-font-style-and-font-size-in-vue2-editor


export default {
  props: ["rpsCase", "showUp", "showDown", "showDelete", "otherLocales"],
  components: {
    EditorHelpImage
  },
  data() {
    return {
      showTitle: false,
      showDescription: false,
      showCaseQuestion: false,
      showDescriptionAboveCases: false,
      showDescriptionBelowCases: false,
      customToolbar: [
    // Copied from source
    // https://github.com/davidroyer/vue2-editor/blob/master/src/helpers/default-toolbar.js
    ["bold", "italic", "underline", "strike"], // toggled buttons
    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
    ["link"],
    [{ font: fonts.whitelist }],
]
    };
  },
  mounted() {},
  computed: {},
  methods: {
    debounce_inputs(e) {
      // Check if event and target exist
      if (!e || !e.target || !e.target.id) {
        return;
      }

      // assumes that input field's id is the same as member in rpsScenario, prefixed by 'input-'
      const field = e.target.id.replace("input-", "");

      if (e.target.value.length <= 1) {
        // Change immediately if field either cleared or inputted somehintg
        Vue.set(this.rpsCase, field, e.target.value);
      } else {
        debounce(() => {
          Vue.set(this.rpsCase, field, e.target.value);
        }, this.debounceDelay)(e);
      }
    },
    down() {
      this.$bus.$emit("rps-case-down", this.rpsCase);
    },
    del() {
      this.$bus.$emit("rps-case-delete", this.rpsCase);
    },
    up() {
      this.$bus.$emit("rps-case-up", this.rpsCase);
    },
    otherLocalesHoverText(field) {
      let locales = "";

      for (let i = 0; i < this.otherLocales.length; i++) {
        if (this.otherLocales[i][field] && this.otherLocales[i][field].length > 0) {
          locales += this.otherLocales[i].locale + ": " + this.otherLocales[i][field] + "\n";
        }
      }
      return locales;
    }
  }
};
</script>

<i18n>
  {
    "en": {
      "case_number": "Case number",
      "title": "Title text *",
      "description": "Description of the case",
      "case_question": "Case question *",
      "facilitator_instructions": "Facilitator instructions for this case",
      "description_above_cases": "Description shown above the answer choices (use only for interval scale questions, e.g. most preferred)",
      "description_below_cases": "Description shown below the answer choices (use only for interval scale questions, e.g. least preferred)",
      "delete": "Delete this case",
      "up": "Move this case up",
      "down": "Move this case down",
      "example": "Example"
    },
    "fi": {
      "case_number": "Tilanne",
      "title": "Otsikko *",
      "description": "Tilanteen kuvaus",
      "case_question": "Tilanteen kysymys *",
      "facilitator_instructions": "Pelinjohtajan ohjeet tilanteessa",
      "description_above_cases": "Vastausvaihtoehtojen yläpuolella näytettävä teksti (käytetään vain välimatka-asteikkokysymyksissä, esimerkiksi 'mieluisin')",
      "description_below_cases": "Vastausvaihtoehtojen alapuolella näytettävä teksti (käytetään vain välimatka-asteikkokysymyksissä, esimerkiksi 'vähiten mieluisa')",
      "delete": "Poista tämä tilanne",
      "up": "Siirrä ylös",
      "down": "Siirrä alas",
      "example": "Esimerkki"
    },
   "sv": {
    },
   "de": {
    },
   "ko": {
    }
  }
  </i18n>

<style scoped>
::v-deep .error {
  border-color: red !important;
}
</style>
